/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthorizedAndroidAppDto } from '../models/AuthorizedAndroidAppDto';
import type { EntityModelResponseContainerAuthorizedAndroidAppDto } from '../models/EntityModelResponseContainerAuthorizedAndroidAppDto';
import type { PagedModelEntityModelAuthorizedAndroidAppDto } from '../models/PagedModelEntityModelAuthorizedAndroidAppDto';
import type { PagedResourcesAssemblerAuthorizedAndroidAppDto } from '../models/PagedResourcesAssemblerAuthorizedAndroidAppDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthorizedAndroidAppControllerService {
    /**
     * @returns PagedModelEntityModelAuthorizedAndroidAppDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        page,
        size = 20,
        sort,
    }: {
        assembler: PagedResourcesAssemblerAuthorizedAndroidAppDto,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelAuthorizedAndroidAppDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/programs/apps',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        programId,
    }: {
        programId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/programs/{programId}/app',
            path: {
                'programId': programId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerAuthorizedAndroidAppDto OK
     * @throws ApiError
     */
    public static read({
        programId,
    }: {
        programId: number,
    }): CancelablePromise<EntityModelResponseContainerAuthorizedAndroidAppDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/programs/{programId}/app',
            path: {
                'programId': programId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerAuthorizedAndroidAppDto OK
     * @throws ApiError
     */
    public static create({
        programId,
        requestBody,
    }: {
        programId: number,
        requestBody: AuthorizedAndroidAppDto,
    }): CancelablePromise<EntityModelResponseContainerAuthorizedAndroidAppDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/programs/{programId}/app',
            path: {
                'programId': programId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerAuthorizedAndroidAppDto OK
     * @throws ApiError
     */
    public static update({
        programId,
        requestBody,
    }: {
        programId: number,
        requestBody: AuthorizedAndroidAppDto,
    }): CancelablePromise<EntityModelResponseContainerAuthorizedAndroidAppDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/programs/{programId}/app',
            path: {
                'programId': programId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
